var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "indexPage" },
    [
      _c("div", { staticClass: "heads" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "head_top" }, [
            _c("div", { staticClass: "head_lg_re" }, [
              _c("button", { on: { click: _vm.toLogin } }, [_vm._v("登陆")]),
              _c("button", { on: { click: _vm.goToJoinUs } }, [_vm._v("注册")]),
            ]),
          ]),
          _c("div", { staticClass: "head_nav" }, [
            _c("div", { staticClass: "head_nav_center" }, [
              _vm._m(0),
              _c("div", { staticClass: "nav02" }, [
                _c(
                  "div",
                  { staticClass: "nav02_r" },
                  _vm._l(_vm.navdata, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        style: {
                          "background-color":
                            _vm.selectIndex == index ? "rgb(255,102,55)" : "",
                          color: _vm.selectIndex == index ? "#FFFFFF" : "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeNavData(index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.dec) + " ")]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "slideshow" }, [
        _c("div", { staticClass: "banner" }, [
          _c(
            "div",
            { staticClass: "bannerImg" },
            _vm._l(_vm.banners, function (v, i) {
              return _c(
                "span",
                {
                  key: v.id,
                  staticClass: "active",
                  style: {
                    opacity: i + 1 == _vm.imageIndex ? "1" : "0",
                    backgroundImage: "url(" + v.image + ")",
                  },
                },
                [
                  v.id == 1
                    ? _c("div", { staticClass: "index_one" }, [
                        _c("div", [
                          _c("p", [_vm._v(_vm._s(v.maxtitle))]),
                          _c("p", [_vm._v(_vm._s(v.mintitle))]),
                          _c("p", [_vm._v(_vm._s(v.doc1))]),
                          _c("p", [_vm._v(_vm._s(v.doc2))]),
                        ]),
                      ])
                    : _vm._e(),
                  v.id == 2
                    ? _c("div", { staticClass: "index_two" }, [
                        _c("div", { staticClass: "top" }, [
                          _c("p", [_vm._v(_vm._s(v.maxtitle))]),
                          _c("p", [_vm._v(_vm._s(v.mintitle))]),
                          _c("p", [_vm._v(_vm._s(v.doc1))]),
                          _c("p", [_vm._v(_vm._s(v.doc2))]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _c(
            "ul",
            { staticClass: "bannerBtn clear-fix" },
            _vm._l(_vm.banners, function (num, index) {
              return _c(
                "li",
                {
                  key: index,
                  on: {
                    click: function ($event) {
                      _vm.imageIndex = index + 1
                    },
                  },
                },
                [
                  _c("a", {
                    staticClass: "aBtn",
                    style: {
                      background: index + 1 == _vm.imageIndex ? "#ff7800" : "",
                    },
                    attrs: { href: "javascript:;" },
                  }),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "viplogin" }, [
        _vm._m(1),
        _c("div", { staticClass: "login_center", attrs: { id: "vipLogin" } }, [
          _vm._m(2),
          _c("div", { staticClass: "lo" }, [
            _c("div", { staticClass: "lo_c" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.account,
                    expression: "account",
                  },
                ],
                attrs: { type: "text", placeholder: "账号" },
                domProps: { value: _vm.account },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.account = $event.target.value
                  },
                },
              }),
              (_vm.lookYN ? "text" : "password") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    attrs: { placeholder: "密码", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.password)
                        ? _vm._i(_vm.password, null) > -1
                        : _vm.password,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.password = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.password = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.password = $$c
                        }
                      },
                    },
                  })
                : (_vm.lookYN ? "text" : "password") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    attrs: { placeholder: "密码", type: "radio" },
                    domProps: { checked: _vm._q(_vm.password, null) },
                    on: {
                      change: function ($event) {
                        _vm.password = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    attrs: {
                      placeholder: "密码",
                      type: _vm.lookYN ? "text" : "password",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
              _c("i", {
                staticClass: "el-icon-view",
                staticStyle: {
                  position: "relative",
                  top: "-0.28rem",
                  left: "2.6rem",
                  transform: "scale(0.8)",
                },
                style: { color: _vm.lookYN ? "red" : "gray" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.lookYN = !_vm.lookYN
                  },
                },
              }),
              _c(
                "button",
                {
                  on: {
                    click: _vm.login,
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.login.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("登录")]
              ),
              _c("div", [
                _c(
                  "p",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$refs.modifyPassword.init()
                      },
                    },
                  },
                  [_vm._v("忘记密码")]
                ),
                _c(
                  "p",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.goToJoinUs()
                      },
                    },
                  },
                  [_vm._v("免费注册")]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "atlas" }, [
            _c(
              "ul",
              _vm._l(_vm.image, function (item, index) {
                return _c("li", { key: index }, [
                  _c("img", { attrs: { src: item.img } }),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "aboutme" }, [
        _c("div", { staticClass: "aboutme_center" }, [
          _c("div", { staticClass: "center_one" }, [
            _c("b", [_vm._v("我们的服务")]),
            _c(
              "ul",
              _vm._l(_vm.weserve, function (item, index) {
                return _c("li", { key: index }, [
                  _c("img", { attrs: { src: item.img, alt: "" } }),
                  _c("p", [_c("span", [_vm._v(_vm._s(item.title))])]),
                  _c("p", [_vm._v(_vm._s(item.doc1))]),
                  _c("p", [_vm._v(_vm._s(item.doc2))]),
                  _c("p", [_vm._v(_vm._s(item.doc3))]),
                ])
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "center_two" }, [
            _c("b", [_vm._v("关于我们的优势")]),
            _c("p", [
              _vm._v(
                "20年的积累的案例，不断简易化的定制流程，资源直采的获利方式，不断"
              ),
            ]),
            _c("p", [_vm._v("满足客户及旅游同业的需求，真诚为您服务")]),
            _c(
              "ul",
              _vm._l(_vm.advantage, function (item, ind) {
                return _c("li", { key: ind }, [
                  _c("img", { attrs: { src: item.img, alt: "" } }),
                  _c("p", [_vm._v(_vm._s(item.num))]),
                  _c("p", [_vm._v(_vm._s(item.doc))]),
                ])
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "list" }, [
          _c(
            "ul",
            _vm._l(_vm.listdata, function (item, index) {
              return _c("li", { key: index }, [
                _c("img", { attrs: { src: item.img, alt: "" } }),
                _c("div", [
                  _c("p", [_vm._v(_vm._s(item.doc1))]),
                  _c("p", [_vm._v(_vm._s(item.doc2))]),
                  _c("span", [_vm._v(_vm._s(item.doc3))]),
                ]),
              ])
            }),
            0
          ),
        ]),
        _vm._m(3),
      ]),
      _c("div", { staticClass: "joinus", attrs: { id: "joinus" } }, [
        _c(
          "div",
          { staticClass: "joinus_center" },
          [
            _c("div", { staticClass: "comment" }, [
              _c(
                "ul",
                _vm._l(_vm.commentdata, function (item, index) {
                  return _c("li", { key: index }, [
                    _c("img", { attrs: { src: item.img, alt: "" } }),
                    _c("div", [
                      _c("p", [_vm._v(_vm._s(item.doc))]),
                      _c("p", [_vm._v(_vm._s(item.name))]),
                    ]),
                  ])
                }),
                0
              ),
            ]),
            _c("SettleInfo"),
          ],
          1
        ),
        _vm._m(4),
        _vm._m(5),
      ]),
      _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "bot2" }, [
          _vm._m(6),
          _c("div", { staticClass: "bot2_center" }, [
            _c(
              "ul",
              _vm._l(_vm.botinfo, function (item, index) {
                return _c("li", { key: index }, [
                  _c("img", { attrs: { src: item.img, alt: "" } }),
                  _vm._v("  "),
                  _c("p", [_vm._v(_vm._s(item.doc))]),
                ])
              }),
              0
            ),
          ]),
          _c(
            "p",
            {
              staticStyle: {
                color: "gray",
                "margin-top": "10px",
                "font-size": "0.12rem",
              },
            },
            [_vm._v("手机版|本站使用|管理登录")]
          ),
        ]),
      ]),
      _c("modifyPassword", { ref: "modifyPassword" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nav01" }, [
      _c("img", {
        attrs: { src: require("@/assets/png/logo-png.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "introduce" }, [
      _c("div", { staticClass: "introduce_center" }, [
        _c("div", { staticClass: "introduce_content" }, [
          _c("b", [_vm._v("公司理念:")]),
          _c("br"),
          _c("span", [
            _vm._v(
              "我们相信：旅游定制是大众市场也是未来旅游的主流市场，每一个独立的需求都是一次客户主动发起的定制。"
            ),
          ]),
          _c("br"),
          _c("span", [_vm._v("我们相信：定制就是单项产品的最佳组合方案。")]),
          _c("br"),
          _c("span", [
            _vm._v("让实现客户的旅游需求从此变的：简单、高效、物美价廉。"),
          ]),
          _c("br"),
          _c("span", [
            _vm._v("我们相信：客户需要的就是高效快速实用的满足需求。"),
          ]),
          _c("br"),
        ]),
        _c("button", [_vm._v("了解更多")]),
        _c("div", { staticClass: "code" }, [
          _c("img", {
            attrs: { src: require("@/assets/jpg/xiaochengxu.jpg") },
          }),
          _c("p", [_vm._v("扫描查看手机版网站")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "center_title" }, [
      _c("span"),
      _vm._v("  会员登录"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bottom" }, [
      _c("div", [
        _c("p", [
          _c("span", [_vm._v("“")]),
          _vm._v("    每一个品牌都是一个产品,但不是所有的产品    "),
          _c("span", [_vm._v("”")]),
        ]),
        _c("p", [_vm._v("都是品牌~")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bot" }, [
      _c("div", [
        _c("p", [_vm._v("给你不一样的体验价值")]),
        _c("span", [_vm._v("旅游行业从业超过20年！")]),
        _c("span", [_vm._v("我们了解大中小型旅游企业的经营模式和需求")]),
        _c("span", [
          _vm._v("我们倡导让客户感知产品的体验价值，而"),
          _c("br"),
          _vm._v("不仅仅是产品的功能。"),
        ]),
        _c("span", [
          _vm._v("更小投入、更低难度、更高效率、更优成本、更高颜"),
          _c("br"),
          _vm._v("值、更多客户"),
        ]),
        _c("button", [_vm._v("了解详情")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bot1" }, [
      _c("b", [_vm._v("联系我们")]),
      _c("p", [_vm._v("如有任何问题请联系我们，我们7*24小时竭诚为您服务")]),
      _c("p", [_vm._v("000-000-0000")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "margin-top": "20px" } }, [
      _c("span", [
        _c(
          "a",
          {
            staticStyle: { "font-size": "0.12rem", color: "#8B989D" },
            attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" },
          },
          [_vm._v("备案号：京ICP备16056012号-5")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }